var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FaCaretDown, FaCaretUp, FaCheck } from 'react-icons/fa';
import styled from 'styled-components';
import { Flyout } from '../../flyout';
import { borderRadius } from '../../styles';
import { CheckIcon } from '../MultiDropDown/style';
import { Icon, ButtonIconRight } from '../Button';
import { DropDownWrapper, ListItem } from './style';
var CustomFlyout = styled(Flyout)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  padding: 0;\n  overflow: hidden;\n"], ["\n  ", ";\n  padding: 0;\n  overflow: hidden;\n"])), borderRadius('small'));
var noop = function () { return null; };
var DropDown = (function (_super) {
    __extends(DropDown, _super);
    function DropDown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            selectedOption: _this.props.options.find(function (option) { return option.value === _this.props.initialValue; })
        };
        _this.dropdownRef = React.createRef();
        _this.hideFlyout = function () { return _this.setState({ isOpen: false }); };
        _this.toggleFlyout = function () {
            _this.setState({
                isOpen: !_this.state.isOpen
            });
        };
        _this.handleClickOutside = function () {
            _this.hideFlyout();
        };
        return _this;
    }
    DropDown.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.initialValue !== prevProps.initialValue) {
            this.setState({ selectedOption: this.props.options.find(function (option) { return option.value === _this.props.initialValue; }) });
        }
    };
    DropDown.prototype.onChange = function (option) {
        this.setState({ selectedOption: option, isOpen: false });
        if (this.props.onChange && option) {
            this.props.onChange(option);
        }
    };
    DropDown.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, options = _b.options, disabled = _b.disabled, align = _b.align, showCheck = _b.showCheck, flyoutStyle = _b.flyoutStyle, dropdownWrapperStyle = _b.dropdownWrapperStyle;
        var showCheckIcon = showCheck && this.state.selectedOption && !this.state.isOpen;
        return (_jsx(DropDownWrapper, __assign({ ref: this.dropdownRef, style: __assign(__assign({}, dropdownWrapperStyle), { width: this.props.width }) }, { children: _jsx(CustomFlyout, __assign({ reference: _jsxs(ButtonIconRight, __assign({ color: "secondary", disabled: disabled, onClick: disabled ? noop : this.toggleFlyout, style: {
                        paddingLeft: this.props.textAlign === 'left' ? '0.75rem' : undefined,
                        width: '100%',
                        textAlign: this.props.textAlign,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }, small: !!this.props.small }, { children: [this.state.selectedOption
                            ? this.state.selectedOption.text
                            : this.props.placeholder || 'Select...', showCheckIcon ? (_jsx(CheckIcon, { as: FaCheck })) : (_jsx(Icon, { as: this.state.isOpen ? FaCaretUp : FaCaretDown }))] })), visible: this.state.isOpen && !disabled, placement: this.props.placement, width: this.props.flyoutWidth ||
                    "".concat(this.dropdownRef.current && this.dropdownRef.current.clientWidth, "px"), type: "dropdown", backgroundColor: "white", style: __assign(__assign({}, (flyoutStyle !== null && flyoutStyle !== void 0 ? flyoutStyle : {})), (_a = {}, _a[align] = "-".concat(this.dropdownRef.current &&
                    this.dropdownRef.current.clientWidth / 2, "px"), _a)), close: function () { return _this.setState({ isOpen: false }); } }, { children: _jsxs("ul", __assign({ role: "listbox" }, { children: [this.props.withUndefinedValue && (_jsx(ListItem, __assign({ role: "option", nowrap: !!align, onClick: function () { return _this.onChange(undefined); }, small: !!this.props.small, selected: this.state.selectedOption === undefined }, { children: this.props.placeholder || 'Select...' }))), options.map(function (option) {
                            var _a;
                            return (_jsx(ListItem, __assign({ tabIndex: "0", role: "option", onClick: function () { return _this.onChange(option); }, small: !!_this.props.small, nowrap: !!align, selected: _this.state.selectedOption &&
                                    _this.state.selectedOption.value === option.value }, { children: (_a = option.element) !== null && _a !== void 0 ? _a : option.text }), option.value));
                        }), this.props.fixedOption && (_jsx(ListItem, __assign({ tabIndex: "0", onClick: function () { return _this.onChange(undefined); }, small: !!this.props.small, nowrap: !!align, addTopBorder: true }, { children: this.props.fixedOption })))] })) })) })));
    };
    DropDown.defaultProps = {
        color: 'secondary',
        placement: 'bottom',
        width: '222px'
    };
    return DropDown;
}(React.Component));
export default DropDown;
var templateObject_1;
//# sourceMappingURL=index.js.map